<p-toast position="top-right"></p-toast>
<router-outlet />
<app-loader></app-loader>